import React, { useState } from 'react';
import { SelectList } from '../TableController/SelectList';
import { continentOptions } from '../Filter/index.js';
export const FilterModal = ({ setIsModalOpen, continent, setContinent }) => ({
	title: 'Filter by continent:',
	BodyComponent: () => {
		const [continentValue, setContinentValue] = useState(continent);
		const select = () => {
			setContinent(continentValue);
			setIsModalOpen(false);
		};
		const clear = () => {
			setContinent(null);
			setIsModalOpen(false);
		};
		const shouldClearBtn =
			Boolean(continent) && continent === continentValue;
		return (
			<div>
				<main
					className="
			modal__content
			--without-margins
			--with-paddings
			bg:light-grey
		"
					id="filter-continent-content"
				>
					<SelectList
						options={continentOptions}
						value={continentValue}
						select={(e, value) => {
							e.preventDefault();
							setContinentValue(value);
						}}
					/>
				</main>
				<footer className="modal__footer flex justify-center">
					<button
						className="modal__btn btn btn__secondary"
						aria-label="Close this dialog window"
						onClick={shouldClearBtn ? clear : select}
					>
						{shouldClearBtn ? 'Clear' : 'Select'}
					</button>
				</footer>
			</div>
		);
	},
});
